<template>
  <div class="one-intro">
    <p>
      <span class="caps">L</span>e bureau de Lestrade est, comme d'habitude, parfaitement rangé. Peut-être trop.
      Cela vous met mal à l'aise. La situation est délicate, la victime est une jeune héritière de
      l'empire austro-hongrois, connue pour sa grande beauté, et sa famille mène la vie dure à la
      police qui n'avance pas sur l'enquête. Vous comprenez à quel point l'on compte sur vous
      pour dénouer cette histoire macabre.
    </p>
    <p>
      Lestrade vous tend une photographie de la scène de crime. Ce n'est pas beau à voir,
      la victime est dans un état qui ne laisse aucun doute sur la violence du meurtre
    </p>
    <p>
      Un élément attire tout de suite votre attention. Au premier plan, une lettre repose au
      sol, comme si la victime en avait pris connaissance juste avant sa mort et l'avait laissée
      tomber lorsque l'assassin l'avait surprise. Vous demandez à Lestrade d'avoir accès à cette
      pièce à conviction et apprenez que celle-ci est en effet une pièce maîtresse de l'enquête. Mais
      jusqu'à maintenant, personne n'a réussi à l'exploiter. Il sort le papier du carton
      rassemblant l'ensemble des éléments de l'enquête. Une fois entre vos mains, à sa lecture, la
      lettre pique au vif votre curiosité.
    </p>
    <p>
      Si même les meurtriers se mettent à coder leurs messages, cela ne va effectivement
      pas faciliter la tâche de la police, et on risque fort de multiplier les recours à vos services.
      Vous comprenez immédiatement pourquoi les forces de l'ordre ont lâché l'affaire. Et
      pourtant, l'odeur du jus de citron ne laisse planer aucun doute : le coupable a fabriqué de
      l'encre sympathique. Vous ne tombez pas dans le piège, une fois révélés les signes cachés,
      vous n'avez aucun mal à venir à bout de cette épreuve. Il ne faut pas oublier que la victime
      devait pouvoir résoudre le code uniquement à l'aide de cette lettre.
    </p>
    <p>
      Lestrade est fier de vous. Il sait maintenant qu'avec l'aide de votre voisine, vous
      devriez être en bonne voie pour résoudre le mystère entourant cet acte sordide. Il vous
      confie la photographie de la scène de crime, vous redonne sa carte, et vous demande de le
      tenir au courant de vos avancées. Il est l'heure de rentrer chez vous. Vous avez du pain sur
      la planche.
    </p>
  </div>
</template>
<script>
export default {
  name: "OneIntro"
};
</script>

<style scoped>
p {
  font-family: "Libre Caslon Text", serif;
  font-size: 15px;
}
.one-intro {
  padding: 5% 10%;
  font-size: 20px;
  overflow: scroll;
  text-align: justify;
  height: 90%;
}
.caps {
  color: rgba(0, 0, 0, 0.7);
  float: left;
  font-size: 110px;
  line-height: 0.8em;
  padding-right: 12px;
  position: relative;
  top: 8px;
}
</style>